import Vue from 'vue'
import airbridge from 'airbridge-web-sdk-loader'

export default ({ env }) => {
  const envType = env.VUE_APP_ENV || 'loc'
  let app, webToken
  if (envType === 'prd' || envType === 'qa') {
    app = env.PRD_AIRBRIDGE_APP_NAME
  } else {
    app = env.STG_AIRBRIDGE_APP_NAME
  }
  if (envType === 'prd' || envType === 'qa') {
    webToken = env.PRD_AIRBRIDGE_WEBTOKEN
  } else {
    webToken = env.STG_AIRBRIDGE_WEBTOKEN
  }
  airbridge.init({
    app,
    webToken,
    cookieWindowInMinutes: 10080,
    utmParsing: true,
  })

  class UserObject {
    constructor (userNo, type, gender, age) {
      this.userNo = userNo
      this.type = type
      this.gender = gender
      this.age = age
    }
  }

  class ProductObject {
    constructor (productID, name, price, brandID, categoryName, position, currency) {
      this.productID = productID
      this.name = name
      this.price = price
      this.currency = currency === '' ? 'KRW' : currency // 화폐기본값 원
      this.position = position
      this.brandID = brandID
      this.categoryName = categoryName
    }
  }

  class ProductListObject {
    constructor (categoryName, categoryNameDetail) {
      this.categoryName = categoryName
      this.categoryNameDetail = categoryNameDetail
    }
  }

  class ClaimObject {
    constructor (orderType, claimType, pyAm, transactionID, productID, name, price, currency, quantity, position) {
      this.orderType = orderType
      this.claimType = claimType
      this.pyAm = pyAm
      this.transactionID = transactionID
      this.productID = productID
      this.name = name
      this.price = price
      this.currency = currency === '' ? 'KRW' : currency // 화폐기본값 원
      this.quantity = quantity
      this.position = position
    }
  }

  class OrderObject {
    constructor (orderType, pyAm, transactionID, productID, name, price, currency, quantity, position, categoryName, brandID, contributionMargin, onlSclCd, onlLclNm) {
      this.orderType = orderType
      this.pyAm = pyAm
      this.transactionID = transactionID
      this.productID = productID
      this.name = name
      this.price = price
      this.currency = currency === '' ? 'KRW' : currency // 화폐기본값 원
      this.quantity = quantity
      this.position = position
      this.categoryName = categoryName
      this.brandID = brandID
      this.contributionMargin = contributionMargin
      this.onlSclCd = onlSclCd
      this.onlLclNm = onlLclNm
    }
  }

  Vue.prototype.$airbridge = {
    UserObject,
    ProductObject,
    ProductListObject,
    ClaimObject,
    OrderObject,
    sendSignUp (userObject, action, label, snsTy) {
      if (!(userObject instanceof UserObject)) {
        return
      }
      airbridge.setUserId(userObject.userNo)
      airbridge.setUserAttribute('type', userObject.type)
      airbridge.setUserAttribute('gender', userObject.gender)
      airbridge.setUserAttribute('age', userObject.age)
      airbridge.events.send('airbridge.user.signup', {
        action,
        label,
        customAttributes: snsTy ? { social: snsTy } : null
      })
    },
    sendSignIn (userObject, action, label, snsTy) {
      if (!(userObject instanceof UserObject)) {
        return
      }
      airbridge.setUserId(userObject.userNo)
      airbridge.setUserAttribute('type', userObject.type)
      airbridge.setUserAttribute('gender', userObject.gender)
      airbridge.setUserAttribute('age', userObject.age)
      airbridge.events.send('airbridge.user.signin', {
        action,
        label,
        customAttributes: snsTy ? { social: snsTy } : null
      })
    },
    sendSignOut () {
      airbridge.events.send('airbridge.user.signout')
      airbridge.clearUser()
    },
    viewProduct (productObject) { // 상품상세조회
      if (!(productObject instanceof ProductObject)) {
        return
      }
      airbridge.events.send('airbridge.ecommerce.product.viewed', {
        label: productObject.categoryName, // 대카테고리 이름
        action: productObject.productID, // 상품번호
        semanticAttributes: {
          products: [{
            productID: productObject.productID,
            name: productObject.name,
            price: productObject.price,
            currency: productObject.currency,
            position: productObject.position,
            brandID: productObject.brandID
          }]
        }
      })
    },
    addToWishiList (productObject) { // 상품찜하기
      if (!(productObject instanceof ProductObject)) {
        return
      }
      airbridge.events.send('airbridge.addToWishlist', {
        label: productObject.categoryName, // 대카테고리 이름
        action: productObject.productID, // 상품번호
        value: productObject.price, // 상품가격
        semanticAttributes: {
          products: [{
            productID: productObject.productID,
            name: productObject.name,
            price: productObject.price,
            currency: productObject.currency,
            position: productObject.position,
            brandID: productObject.brandID
          }]
        }
      })
    },
    goHome () { // 홈 화면에 이동한 시점
      airbridge.events.send('airbridge.ecommerce.home.viewed')
    },
    viewProductList (productListObject) { // 상품 리스트 조회
      if (!(productListObject instanceof ProductListObject)) {
        return
      }
      airbridge.events.send('airbridge.ecommerce.productList.viewed', {
        action: productListObject.categoryName, // 상품 리스트 조회 화면
        label: productListObject.categoryNameDetail, // 상품 리스트 조회 하위 페이지
      })
    },
    viewSearchResult (searchTerm) {
      airbridge.events.send('airbridge.ecommerce.searchResults.viewed', {
        semanticAttributes: { query: searchTerm }
      })
    },
    orderCanceled (claimObject) { // 상품상세조회
      if (!(claimObject instanceof ClaimObject)) {
        return
      }
      airbridge.events.send('airbridge.ecommerce.order.canceled', {
        action: claimObject.orderType, // 택배배송: std_delv, 매장픽업: store_pickup, 대량배송: bulk_delv, 오늘배송: today_delv
        label: claimObject.claimType, // 고객취소: user_cancel, 결품취소: stgd_cancel, 미수령취소: not_pkup_cancel, 미입금취소: not_deposit_cancel, 관리자취소: admin_cancel
        value: claimObject.pyAm,
        semanticAttributes: {
          products: [{
            productID: claimObject.productID,
            name: claimObject.name,
            price: claimObject.price,
            currency: claimObject.currency,
            quantity: claimObject.quantity,
            position: claimObject.position
          }],
          transactionID: claimObject.transactionID
        }
      })
    },
    orderAddedToCart (orderObject) {
      if (!(orderObject instanceof OrderObject)) {
        return
      }
      airbridge.events.send('airbridge.ecommerce.product.addedToCart', {
        action: orderObject.productID,
        label: orderObject.categoryName, // 대카테고리 이름
        semanticAttributes: {
          products: [{
            productID: orderObject.productID,
            name: orderObject.name,
            price: orderObject.price,
            currency: orderObject.currency,
            quantity: orderObject.quantity,
            brandID: orderObject.brandID,
            position: orderObject.position
          }],
          currency: orderObject.currency
        }
      })
    },
    orderInitiateCheckout (orderObject) {
      if (!(orderObject instanceof OrderObject)) {
        return
      }
      airbridge.events.send('airbridge.initiateCheckout', {
        action: orderObject.orderType, // 택배배송: std_delv, 매장픽업: store_pickup, 대량배송: bulk_delv, 오늘배송: today_delv
        semanticAttributes: {
          products: [{
            productID: orderObject.productID,
            name: orderObject.name,
            price: orderObject.price,
            currency: orderObject.currency,
            quantity: orderObject.quantity,
            position: orderObject.position,
            categoryID: orderObject.onlSclCd,
            categoryName: orderObject.onlLclNm
          }],
          currency: orderObject.currency
        }
      })
    },
    orderCompleted (orderObject, products) {
      if (!(orderObject instanceof OrderObject)) {
        return
      }
      const payload = {
        action: orderObject.orderType, // 택배배송: std_delv, 매장픽업: store_pickup, 대량배송: bulk_delv, 오늘배송: today_delv
        value: orderObject.pyAm, // 결제금액
        semanticAttributes: {
          products: (products || []).map(p => ({
            productID: String(p.productID),
            name: p.name,
            price: Number(p.price),
            currency: p.currency,
            quantity: Number(p.quantity),
            position: p.position,
            categoryID: p.categoryID,
            categoryName: p.categoryName
          })),
          transactionID: orderObject.transactionID,
          contributionMargin: orderObject.contributionMargin,
        },
      }
      airbridge.events.send('airbridge.ecommerce.order.completed', payload)
    },
    orderCompleteTransaction (orderObject) {
      if (!(orderObject instanceof OrderObject)) {
        return
      }
      const payload = {
        action: orderObject.orderType,
        value: Number(orderObject.price) * Number(orderObject.quantity),
        semanticAttributes: {
          transactionID: String(orderObject.transactionID),
          currency: orderObject.currency,
          products: [{
            productID: String(orderObject.productID),
            name: orderObject.name,
            price: Number(orderObject.price),
            currency: orderObject.currency,
            quantity: Number(orderObject.quantity),
            position: orderObject.position,
            categoryID: orderObject.onlSclCd,
            categoryName: orderObject.onlLclNm
          }]
        },
        customAttributes: {
          contributionMargin: orderObject.contributionMargin
        }
      }
      airbridge.events.send('order_complete_transaction', payload)
    }
  }
}
